import React, {useEffect, useState} from "react";

// Styles
import DelawareAsiaContainer from "./DelawareAsia.styles";

// Components
import Latest from "components/Screens/Fees/Common/FundTabs/LatestTab/Latest";
import Reports from "components/Screens/Fees/Common/FundTabs/ReportsTab/Reports";
import SubTabs from "components/Common/SubTabs/SubTabs";
import Archive from "components/Screens/Fees/Common/FundTabs/ArchiveTab/Archive";

// utils
import {FeesReportDetails, setFeesReportDetails} from "utils/fees.utils";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";

interface DelawareAsiaProps {
    region: string;
}

const DelawareAsia = ({ region }: DelawareAsiaProps) => {
    const [feesForcastReportDetails, setFeesForcastReportDetails] =
        useState<FeesReportDetails>({ workspaceId: "", reportId: "" });
    const [feesDiscrepancyReportDetails, setFeesDiscrepancyReportDetails] =
        useState<FeesReportDetails>({ workspaceId: "", reportId: "" });

    useEffect(() => {
        setFeesReportDetails("DELAWARE_ASIA_FEES", setFeesForcastReportDetails);
        setFeesReportDetails("DELAWARE_ASIA_DISCREPANCY", setFeesDiscrepancyReportDetails);
    }, []);

    return (
        <DelawareAsiaContainer>
            <SubTabs
                defaultTab="latest"
                subTabs={[
                    {
                        value: "latest",
                        title: "LATEST",
                        content: (
                            <Latest
                                region={region}
                                fund="delaware"
                                period="latest"
                            />
                        ),
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "reports",
                        title: "REPORTS SIGN OFF",
                        content: <Reports region={region} fund="delaware" />,
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "fee_report",
                        title: "FEE REPORT",
                        content: (
                            <div className="iframeContainer">
                                {feesForcastReportDetails.reportId && (
                                    <PowerBIDashboard
                                        reportId={
                                            feesForcastReportDetails.reportId
                                        }
                                        workspaceId={
                                            feesForcastReportDetails.workspaceId
                                        }
                                    ></PowerBIDashboard>
                                )}
                            </div>
                        ),
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "discrepancy_report",
                        title: "DISCREPANCY REPORT",
                        content: (
                            <div className="iframeContainer">
                                {feesDiscrepancyReportDetails.reportId && (
                                    <PowerBIDashboard
                                        reportId={
                                            feesDiscrepancyReportDetails.reportId
                                        }
                                        workspaceId={
                                            feesDiscrepancyReportDetails.workspaceId
                                        }
                                    ></PowerBIDashboard>
                                )}
                            </div>
                        ),
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "archive",
                        title: "ARCHIVE",
                        content: <Archive fund="delaware" region="asia" />,
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                ]}
            />
        </DelawareAsiaContainer>
    );
};
export default DelawareAsia;
